import { useMemo } from "react";
import useAuthStore from "~/store/auth";
import useSettingPrefStore from "~/store/setttingPref";
import { useCounterparties } from "../query";

export function useSelectedEntityContext() {
  const authenticated = useAuthStore((state) => state.authenticated);
  const entity = useSettingPrefStore((state) => state.entity);
  const { data = [], isLoading, error } = useCounterparties(!authenticated());

  const result = useMemo(() => {
    if (!entity) return null;
    return data.find((d) => d.id === entity);
  }, [data, entity]);

  return {
    data: result,
    isLoading,
    error,
  };
}
